import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DeleteConfirmationModalComponent } from '../modals';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-voluntary-table-component',
    templateUrl: './voluntary-component.html',
    styleUrls: ['./voluntary-component.scss']
})

export class VoluntaryTableComponent implements OnInit {
    @Input() data_array : Array<any>;
    @Output() delete = new EventEmitter<any>();
    @Output() edit = new EventEmitter<any>();

    constructor(private modalService: NgbModal) {
    	
    }

    ngOnInit() {}

    deleteAction(data){
        const modalRef = this.modalService.open(DeleteConfirmationModalComponent);
              const p1 = data.organization;
              const p2 = data.description;

              modalRef.componentInstance.Title = " "+p1+"/"+p2;
              modalRef.result.then((result) => {
                    if(result.status)
                        this.delete.emit(data.id);
                  }).catch((error) => {
              });
    }

    editAction(data){
        this.edit.emit({... data});
    }
}
